import {businessCalendarMonthRange} from 'src/api/business-time'
import {parseApiDate, toApiDateString} from 'src/jobs/job-schedule-format'

export type RentalReportSearch = {
    start?: string
    end?: string
}

export function validateRentalReportSearch(search: Record<string, unknown>): RentalReportSearch {
    const result: RentalReportSearch = {}
    if (typeof search['start'] === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(search['start'])) {
        result.start = search['start']
    }
    if (typeof search['end'] === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(search['end'])) {
        result.end = search['end']
    }
    return result
}

export function defaultRentalReportDateRange() {
    return businessCalendarMonthRange()
}

export function resolveRentalReportSearch(search: RentalReportSearch) {
    const defaults = defaultRentalReportDateRange()
    return {
        startDate: search.start ?? defaults.startDate,
        endDate: search.end ?? defaults.endDate,
    }
}

export function rentalReportDateSearchValue(date: Date) {
    return toApiDateString(date)
}

export function parseDateInputValue(value: string | Date | null) {
    if (value == null) {
        return null
    }
    if (value instanceof Date) {
        return value
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return parseApiDate(value)
    }
    return new Date(value)
}
